import { jsx as _jsx } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Dropdown } from "@/components/Dropdown";
import { SearchFormContext } from "@/components/cortex/components/SearchForm/SearchFormContext";
import { getUpdatedSearchParams } from "@/components/utils";
export function CountryDropdown() {
    var searchFormContext = useContext(SearchFormContext);
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var countryConfig = useContext(GlobalContext).countryConfig;
    var countryValue = searchFormContext.countryValue, setCountryValue = searchFormContext.setCountryValue, queryValue = searchFormContext.queryValue, locationValue = searchFormContext.locationValue, isRemoteOnlyValue = searchFormContext.isRemoteOnlyValue, companyValue = searchFormContext.companyValue, occupationValue = searchFormContext.occupationValue;
    var selectedValue = countryValue || countryConfig.selectedCountry;
    var countryIcon = (_jsx(FontAwesomeIcon, { icon: faGlobe, opacity: 1, title: "Country Icon", titleId: "country-icon" }));
    function handleChange(country) {
        if (typeof country === "string") {
            setCountryValue(country);
            var updatedParams = getUpdatedSearchParams(searchParams, queryValue, locationValue, isRemoteOnlyValue, undefined, country, companyValue, occupationValue);
            setSearchParams(updatedParams);
        }
    }
    return (_jsx(Dropdown, { icon: countryIcon, label: "Jobs in: ", buttonName: "Countries", optionsName: "co", menuTitle: "Country", selectedValue: selectedValue, values: countryConfig.supportedCountries, handleChange: handleChange }));
}
